import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-weight: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    & + & {\n        margin-left: 20px;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap-reverse;\n    justify-content: flex-end;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    .react-datepicker-popper {\n        z-index: 100;\n    }\n    .react-datepicker-popper[data-placement^='bottom'] {\n        margin-top: 10px;\n    }\n    .react-datepicker-popper[data-placement^='top'] {\n        margin-bottom: 10px;\n    }\n    .react-datepicker-popper[data-placement^='right'] {\n        margin-left: 8px;\n    }\n    .react-datepicker-popper[data-placement^='left'] {\n        margin-right: 8px;\n    }\n\n    .react-datepicker__day-names,\n    .react-datepicker__week {\n        white-space: nowrap;\n    }\n\n    .react-datepicker__day-name,\n    .react-datepicker__day {\n        display: inline-block;\n        box-sizing: border-box;\n        border-radius: 50%;\n        border: 2px solid transparent;\n        width: 40px;\n        height: 40px;\n        line-height: 36px;\n        text-align: center;\n    }\n\n    .react-datepicker__day-name {\n        color: ", ";\n    }\n\n    .react-datepicker__day {\n        outline: none;\n        cursor: pointer;\n    }\n    .react-datepicker__day:hover,\n    .react-datepicker__day:focus {\n        background-color: ", ";\n    }\n    .react-datepicker__day:active {\n        background-color: ", ";\n    }\n\n    .react-datepicker__day--today {\n        border-color: ", ";\n        color: ", ";\n        font-weight: 500;\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__day:focus.react-datepicker__day--keyboard-selected,\n    .react-datepicker__day--in-range,\n    .react-datepicker__day--in-selecting-range {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    .react-datepicker__day--selected:hover,\n    .react-datepicker__day--selected:focus,\n    .react-datepicker__day:focus.react-datepicker__day--keyboard-selected:hover,\n    .react-datepicker__day:focus.react-datepicker__day--keyboard-selected:focus,\n    .react-datepicker__day--in-selecting-range:hover,\n    .react-datepicker__day--in-selecting-range:focus,\n    .react-datepicker__day--in-range:hover,\n    .react-datepicker__day--in-range:focus {\n        border-color: ", ";\n        background-color: ", ";\n    }\n\n    .react-datepicker__day--selected:active,\n    .react-datepicker__day:focus.react-datepicker__day--keyboard-selected:active,\n    .react-datepicker__day--in-selecting-range:active,\n    .react-datepicker__day--in-range:active {\n        background-color: ", ";\n    }\n\n    .react-datepicker__input-time-container {\n        margin-top: 10px;\n    }\n    .react-datepicker__input-time-container .react-datepicker-time__caption {\n        margin-bottom: 3px;\n        color: ", ";\n        ", ";\n    }\n\n    .react-datepicker__day--disabled {\n        cursor: default;\n        color: ", ";\n    }\n    .react-datepicker__day--disabled:hover,\n    .react-datepicker__day--disabled:focus,\n    .react-datepicker__day--disabled:active {\n        background-color: transparent;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    padding: 0;\n    border: 0;\n    width: ", ";\n\n    .react-datepicker__input-container {\n        position: relative;\n        display: inline-block;\n        width: 100%;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import { transparentize } from 'polished';
import DatePicker from 'react-datepicker';
import { isWeekend, set } from 'date-fns';
import { Button } from '../Button';
import { Divider } from '../Divider';
import { typography } from '../mixins';
import { noop } from '../helpers';
import { DatepickerHeader } from './DatepickerHeader';
import { DatepickerContainer } from './DatepickerContainer';
import { DatepickerInput } from './DatepickerInput';
import { DatepickerTimeInput, limitDate } from './DatepickerTimeInputProps';
var TimeLabel = {
  en: 'Time',
  ru: 'Время',
  he: 'זמן',
  es: 'Hora'
};
var StyledDatepicker = styled.div(_templateObject(), function (_ref) {
  var fullWidth = _ref.fullWidth,
      width = _ref.width;
  return fullWidth ? '100%' : width ? "".concat(width, "px") : 'auto';
});
var PopperContainer = styled.div(_templateObject2(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.gray.gray400;
}, function (_ref3) {
  var theme = _ref3.theme;
  return transparentize(0.96, theme.palette.primary.main);
}, function (_ref4) {
  var theme = _ref4.theme;
  return transparentize(0.92, theme.palette.primary.main);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.primary.main;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.primary.main;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.palette.primary.main;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.palette.primary.contrastText;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.palette.primary.hover;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.palette.primary.hover;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.palette.primary.active;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.palette.gray.gray900;
}, typography('body1'), function (_ref13) {
  var theme = _ref13.theme;
  return theme.palette.gray.gray200;
});
var ButtonsContainer = styled.div(_templateObject3());
var ActionButton = styled(Button)(_templateObject4());
var Weekend = styled.span(_templateObject5(), function (_ref14) {
  var theme = _ref14.theme;
  return theme.typography.action1.fontWeight;
});

function renderDayContents(day, date) {
  return isWeekend(date) ? React.createElement(Weekend, null, day) : day;
}

function useOpenCloseCalendar(setIsWorking) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpened = _useState2[0],
      setIsOpened = _useState2[1];

  var openCalendar = useCallback(function () {
    return setIsOpened(true);
  }, []);
  var closeCalendar = useCallback(function () {
    setIsWorking(false);
    setIsOpened(false);
  }, [setIsWorking]);
  var toggleCalendar = useCallback(function (_ref15) {
    var _ref15$nativeEvent = _ref15.nativeEvent,
        target = _ref15$nativeEvent.target,
        code = _ref15$nativeEvent.code;
    var eventTarget = target;

    if (code !== 'Space' || eventTarget.nodeName !== 'INPUT') {
      return;
    }

    setIsOpened(!isOpened);
  }, [isOpened]);
  return {
    isOpened: isOpened,
    openCalendar: openCalendar,
    closeCalendar: closeCalendar,
    toggleCalendar: toggleCalendar
  };
}

var popperModifiers = {
  preventOverflow: {
    enabled: false
  },
  hide: {
    enabled: false
  },
  flip: {
    enabled: false
  }
};
export function Datepicker(_a) {
  var locale = _a.locale,
      selected = _a.selected,
      _a$isClearable = _a.isClearable,
      isClearable = _a$isClearable === void 0 ? false : _a$isClearable,
      showTimeInput = _a.showTimeInput,
      _a$dateFormat = _a.dateFormat,
      dateFormat = _a$dateFormat === void 0 ? showTimeInput ? 'PPp' : 'PP' : _a$dateFormat,
      _a$strings = _a.strings,
      strings = _a$strings === void 0 ? {} : _a$strings,
      _a$inputProps = _a.inputProps,
      inputProps = _a$inputProps === void 0 ? {} : _a$inputProps,
      timeInputProps = _a.timeInputProps,
      showActionButtons = _a.showActionButtons,
      minDate = _a.minDate,
      maxDate = _a.maxDate,
      _a$popperPlacement = _a.popperPlacement,
      popperPlacement = _a$popperPlacement === void 0 ? 'bottom-start' : _a$popperPlacement,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$onChange = _a.onChange,
      onChange = _a$onChange === void 0 ? noop : _a$onChange,
      props = __rest(_a, ["locale", "selected", "isClearable", "showTimeInput", "dateFormat", "strings", "inputProps", "timeInputProps", "showActionButtons", "minDate", "maxDate", "popperPlacement", "disabled", "onChange"]);

  var minDateFixed;
  var maxDateFixed;

  if (minDate) {
    minDateFixed = set(minDate, {
      seconds: 0,
      milliseconds: 0
    });
  }

  if (maxDate) {
    maxDateFixed = set(maxDate, {
      seconds: 0,
      milliseconds: 0
    });
  }

  var timeInputLabel = useMemo(function () {
    var _a;

    return TimeLabel[((_a = locale === null || locale === void 0 ? void 0 : locale.code) === null || _a === void 0 ? void 0 : _a.substr(0, 2)) || 'en'] || TimeLabel.en;
  }, [locale]);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isWorking = _useState4[0],
      setIsWorking = _useState4[1];

  var _useOpenCloseCalendar = useOpenCloseCalendar(setIsWorking),
      isOpened = _useOpenCloseCalendar.isOpened,
      openCalendar = _useOpenCloseCalendar.openCalendar,
      closeCalendar = _useOpenCloseCalendar.closeCalendar,
      toggleCalendar = _useOpenCloseCalendar.toggleCalendar;

  var onInputClick = useCallback(function () {
    if (!disabled) {
      openCalendar();
    }
  }, [disabled, openCalendar]);

  var _useState5 = useState(selected),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var handleChange = useCallback(function (value) {
    setIsWorking(true);
    var handlerResult = onChange({
      target: {
        value: value
      }
    });

    if (handlerResult instanceof Promise) {
      handlerResult.then(closeCalendar, function () {
        return setIsWorking(false);
      });
    } else {
      closeCalendar();
    }
  }, [onChange, closeCalendar]);
  var handleDateChange = useCallback(function (date) {
    !Array.isArray(date) && setValue(date);

    if (!date) {
      handleChange(null);
    }
  }, [setValue]);
  var selectDate = useCallback(function (date) {
    var limitedDate = limitDate(date, minDateFixed, maxDateFixed);
    setValue(limitedDate);

    if (!showActionButtons) {
      handleChange(limitedDate);
    }
  }, [setValue, showActionButtons]);
  var applyChanges = useCallback(function () {
    setValue(value);
    handleChange(value);
  }, [setValue, handleChange, value]);
  var discardChanges = useCallback(function () {
    if (isWorking) {
      return;
    }

    setValue(selected);
    closeCalendar();
  }, [setValue, selected, isWorking]);
  var clearDate = useCallback(function (event) {
    event.stopPropagation();
    setValue(null);
  }, []);
  var customInput = React.createElement(DatepickerInput, Object.assign({}, inputProps, {
    clear: isClearable,
    onClear: clearDate
  }));
  var customTimeInput = React.createElement(DatepickerTimeInput, Object.assign({
    width: 100
  }, timeInputProps, {
    type: 'time',
    currentDate: value,
    minDate: minDateFixed,
    maxDate: maxDateFixed
  }));
  return React.createElement(StyledDatepicker, {
    fullWidth: inputProps.fullWidth,
    width: inputProps.width
  }, React.createElement(DatePicker, Object.assign({}, props, {
    locale: locale,
    open: isOpened,
    selected: value,
    onChange: handleDateChange,
    onSelect: selectDate,
    dateFormat: dateFormat,
    shouldCloseOnSelect: false,
    disabled: disabled,
    fixedHeight: true,
    minDate: minDateFixed,
    maxDate: maxDateFixed,
    customInput: customInput,
    showTimeInput: showTimeInput,
    customTimeInput: customTimeInput,
    timeInputLabel: timeInputLabel,
    calendarContainer: DatepickerContainer,
    renderCustomHeader: DatepickerHeader(locale),
    renderDayContents: renderDayContents,
    showPopperArrow: true,
    popperContainer: PopperContainer,
    popperModifiers: popperModifiers,
    popperPlacement: popperPlacement,
    onInputClick: onInputClick,
    onClickOutside: discardChanges,
    onKeyDown: toggleCalendar
  }), showActionButtons && React.createElement(React.Fragment, null, React.createElement(Divider, null), React.createElement(ButtonsContainer, null, React.createElement(ActionButton, {
    variant: 'text',
    onClick: discardChanges
  }, strings.cancel), React.createElement(ActionButton, {
    variant: 'filled',
    working: isWorking,
    disabled: (selected === null || selected === void 0 ? void 0 : selected.getTime()) === (value === null || value === void 0 ? void 0 : value.getTime()),
    onClick: applyChanges
  }, strings.ok)))));
}